"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRole = void 0;
exports.getUserRoles = getUserRoles;
exports.getUserRoleFrom = getUserRoleFrom;
var UserRole;
(function (UserRole) {
    UserRole["Student"] = "student";
    UserRole["Teacher"] = "teacher";
    UserRole["Author"] = "author";
    UserRole["DistrictAdmin"] = "district-admin";
    UserRole["SchoolAdmin"] = "school-admin";
})(UserRole || (exports.UserRole = UserRole = {}));
function getUserRoles() {
    return [
        UserRole.Student,
        UserRole.Teacher,
        UserRole.Author,
        UserRole.DistrictAdmin,
        UserRole.SchoolAdmin,
    ];
}
function getUserRoleFrom(value) {
    return getUserRoles().find(function (type) { return type === value; });
}
